import { ApiNotFoundComponentModule } from "./../../_component/api-not-found/api-not-found.component.module";
import { BreadcrumbComponentModule } from "./../../_component/breadcrumb/breadcrumb.module";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { PaginationClientSideModule } from "src/app/app/_component/pagination-client-side/pagination-client-side.module";
import { SelectDropdownModule } from "src/app/app/_component/select-dropdown/select-dropdown.module";
import { UploadAttachmentModule } from "src/app/app/_component/upload-attachment/upload-attachment.module";
import { HeaderModule } from "src/app/_component/header/header.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { CardComponentModule } from "../../_component/_structural/card/card.module";
import { ParkingSpaceEditPageRoutingModule } from "./parking-space-edit-routing.module";
import { ParkingSpaceEditPage } from "./parking-space-edit.page";
import { SpaceEditComponentModule } from "../../_component/_space/space-edit/space-edit.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    ParkingSpaceEditPageRoutingModule,
    SelectDropdownModule,
    SharedDirectivesModule,
    UploadAttachmentModule,
    PaginationClientSideModule,
    LoadingStiModule,
    HeaderModule,
    CardComponentModule,
    BreadcrumbComponentModule,
    ApiNotFoundComponentModule,
    SpaceEditComponentModule,
  ],
  declarations: [ParkingSpaceEditPage],
})
export class ParkingSpaceEditPageModule {}
